module.exports = __webpack_public_path__ + "static/media/qr-code-apple-onboarding-stg.9ed14da6.png";